import React from 'react';

import {
  Breakpoints,
  TextAlignment,
  TextAppearance,
  TextColor,
  TextCustom,
  TextLineHeight,
  TextSize,
  TextTag,
  TextWeight,
  useTheme,
} from '@vw-marketing/us-components';

import ProfileAvatar from '../profile-avatar/ProfileAvatar';
import {
  Greeting,
  UserContainer,
  UserInfo,
  UserProfileContainer,
} from './styles';

interface UserProfileProps {
  name: string;
  greeting?: string;
  avatarSize?: number;
  avatarBackgroundColor?: string;
  avatarColor?: string;
  className?: string;
}

const UserProfile: React.FC<UserProfileProps> = ({
  name,
  avatarSize = 60,
  avatarBackgroundColor,
  avatarColor,
  className,
  greeting,
}) => {
  const theme = useTheme();
  const resolvedAvatarBackgroundColor = avatarBackgroundColor ?? theme.colors.content.active;
  const resolvedAvatarColor = avatarColor ?? theme.colors.content.inverted;
  return (
    <UserProfileContainer>
      <UserContainer className={className}>
        <ProfileAvatar
          name={name}
          size={avatarSize}
          backgroundColor={resolvedAvatarBackgroundColor}
          color={resolvedAvatarColor}
        />
        <UserInfo>
          {greeting && (
            <Greeting>
              <TextCustom
                appearance={TextAppearance.copy200}
                tag={TextTag.p}
                style={{
                  [Breakpoints.default]: {
                    color: TextColor.secondary,
                    fontWeight: TextWeight.regular,
                    fontSize: TextSize.TextSize16,
                    lineHeight: TextLineHeight.TextLineHeight24,
                    textAlign: TextAlignment.left,
                  },
                  [Breakpoints.b560]: {
                    fontSize: TextSize.TextSize20,
                    lineHeight: TextLineHeight.TextLineHeight32,
                  },
                }}
              >
                {greeting},
              </TextCustom>
            </Greeting>
          )}
          <TextCustom
            appearance={TextAppearance.copy200}
            tag={TextTag.p}
            style={{
              [Breakpoints.default]: {
                fontSize: TextSize.TextSize28,
                fontWeight: TextWeight.bold,
                color: TextColor.primary,
                lineHeight: TextLineHeight.TextLineHeight32,
                textAlign: TextAlignment.left,
              },
              [Breakpoints.b560]: {
                fontSize: TextSize.TextSize32,
                lineHeight: TextLineHeight.TextLineHeight36,
              },
            }}
          >
            {name}
          </TextCustom>
        </UserInfo>
      </UserContainer>
    </UserProfileContainer>
  );
};

export default UserProfile;
